// The routes this module owns, RELATIVE to where it is mounted. The CDN service router mounts it under
// the service-scoped CDN route; that prefix belongs to the CDN console, so it is not written here.
export const eaglePaths = {
  domains: 'domains',
  /** The domain setup wizard. Not under `domains/`: that prefix is the domain page's pattern and would swallow it. */
  newDomain: 'new-domain',
  /** The pattern of the domain page, inside <Routes>. */
  domain: 'domains/:domainId/*',
} as const;
